<template>
  <div>
    <!-- =================================Loading ======================================================= -->
    <div
      style="margin: 0"
      class="loading-waiting"
      v-bind:style="{ display: finish == false ? 'none' : '' }"
    >
      <div>
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
        <div class="load-wrapp">
          <div class="load-6">
            <div class="letter-holder">
              <div class="l-1 letter">l</div>
              <div class="l-2 letter">o</div>
              <div class="l-3 letter">a</div>
              <div class="l-4 letter">d</div>
              <div class="l-5 letter">i</div>
              <div class="l-6 letter">n</div>
              <div class="l-7 letter">g</div>
              <div class="l-8 letter">.</div>
              <div class="l-9 letter">.</div>
              <div class="l-10 letter">.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- =================================Loading ======================================================= -->

    <div class="bg-image">
        <img :src="logo" alt="logo" class="logo_cover" />
        <div class="wrapper">
            <v-card class="card-property">
                <v-row class="ma-2">
                    <!-- <v-col cols="12">
                        <v-autocomplete
                            label="ค้นหาบริษัท"
                            v-model="biz_name"
                            :items="list_items_biz"
                            height="50px"
                            dense
                            solo
                            class="custom-select"
                            @change="selectBiz()"
                        ></v-autocomplete>
                    </v-col> -->
                    <v-col cols="12">
                      <v-text-field
                        class="custom-search"
                        v-model="search"
                        label="ค้นหาบริษัท"
                        prepend-inner-icon="mdi-magnify"
                        variant="outlined"
                        hide-details
                        single-line
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers"
                        :items="list_items_biz"
                        :search="search"
                        hide-default-footer
                        hide-default-header
                        height="350"
                        :items-per-page="1000"
                      >
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn color="#55B9D9" dark @click="selectBiz(item)">
                            เลือก
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                    <v-col align="right" cols="12">
                      <v-btn color="red" dark @click="logout()">
                          ออกจากระบบ
                      </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </div>
    </div>
  </div>
</template>

<script>
import home_inet from "../assets/home_inet.png";
import inet_logo from "../assets/inetlogo.png";

export default {
    data() {
        return {
            logo: home_inet,
            inet_logo: inet_logo,
            finish: false,
            biz_name: "",
            items_biz: [],
            list_items_biz: [],
            search : "",
            headers : [
              {
                text: "Company code",
                value: "company_code",
                width: "150px",
              },
              {
                text: "Biz Name",
                value: "name_th",
                width: "200px",
              },
              {
                text: "Action",
                value: "action",
                width: "40px",
                align: "right",
              },
            ]
        };
    },
    created() {
        this.items_biz = JSON.parse(localStorage.getItem('biz_all'));
    
        if(this.items_biz){
            this.items_biz.forEach((element => {
                this.list_items_biz.push({
                  company_code : element.company_code,
                  id : element.id,
                  name_th : element.first_name_th,
                  role : element.role
                })
            }))
        }
        // this.listBiz();
    },
     methods: {
        listBiz(){
          let headers = {
            headers: {
              Authorization:
                "Bearer " +
                localStorage.getItem("acces_token") +
                "," +
                localStorage.getItem("secret"),
            },
          };
          this.axios
            .get(process.env.VUE_APP_API + "/biz/detail", headers)
            .then((response) => {
              this.items_biz = response.data.employee_data
              // console.log(this.items_biz)
            })
            .catch((error) => {
              console.log(error);
            });
        },
        selectBiz(item) {
          // console.log(item)
            // if(this.items_biz){
            //     this.items_biz.forEach((element => {
            //     if(element.first_name_th == this.biz_name){
            //         if(element.role != "" ){
            //             localStorage.setItem("biz_id" , element.id);
            //             localStorage.setItem("role" , element.role);
            //             localStorage.setItem("biz_name" , this.biz_name);
            //             this.$router.push("/invoice");
            //         }else{
            //         this.$swal.fire({
            //             title: "<h4>ไม่พบสิทธิ์การเข้าใช้งานของ</h4>",
            //             text: this.biz_name,
            //             icon: "error",
            //             showConfirmButton: false,
            //             timer: 3000,
            //         });
            //         }
                    
            //     }
            //     }))
            // }

            if(item.role != ""){
              localStorage.setItem("biz_id" , item.id);
              localStorage.setItem("role" , item.role);
              localStorage.setItem("biz_name" , item.name_th);
              localStorage.setItem("sorgcode" , item.company_code);
              this.$router.push("/invoice");
            }else{
              this.$swal.fire({
                title: "<h4>ไม่พบสิทธิ์การเข้าใช้งานของ</h4>",
                text: item.name_th,
                icon: "error",
                showConfirmButton: false,
                timer: 3000,
              });
            }
        },
        logout() {
          localStorage.clear();
          this.$router.push("/login");
        },
     }

}
</script>

<style lang="scss">
@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Medium.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

.text {
  font-family: "Bai_Jamjuree" !important;
}
.custom-search {
  border-color: #D9D9D9;
}
.custom-select {
  width: 100% !important;
  margin-top: 5px !important;
  z-index: 1001 !important;
  font-size: 16px !important;
  font-family: "Bai_Jamjuree" !important;
}
.card-property {
  border-radius: 10px;
  justify-content: center;
  justify-self: center;
  /* width: 1096px; */
  width: 768px;
  height: 530px;
}
.wrapper {
  width: 100%;
  height: 100vh;

  padding: 30px 15px;
  background-image: url(../assets/home_inet.png);

  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.logo_cover {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-image {
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden !important;
}
// ======================================loading..==============================================//
.loading-waiting {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: #ecf5ff62;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.load-4 .ring-1 {
  animation: loadingD 1.5s 0.3s cubic-bezier(0.17, 0.37, 0.43, 0.67) infinite;
}

@keyframes loadingD {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ring-1 {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  padding: 7px;
  border: 8px dashed #4b9cdb;
  border-radius: 100%;
}

.load-6 .letter {
  animation-name: loadingF;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
  animation-direction: linear;
}

.letter-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b9cdb;
  font-size: 20px;
}

.l-1 {
  animation-delay: 0.48s;
}

.l-2 {
  animation-delay: 0.6s;
}

.l-3 {
  animation-delay: 0.72s;
}

.l-4 {
  animation-delay: 0.84s;
}

.l-5 {
  animation-delay: 0.96s;
}

.l-6 {
  animation-delay: 1.08s;
}

.l-7 {
  animation-delay: 1.2s;
}

.l-8 {
  animation-delay: 1.32s;
}

.l-9 {
  animation-delay: 1.44s;
}

.l-10 {
  animation-delay: 1.56s;
}

@keyframes loadingF {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
// ======================================End loading..==========================================//
</style>